export default function FindingCategoriesDirective() {
  return {
    template: require('./finding-categories.html'),
    scope: {
      auditId: '=',
      customerId: '=',
      coordinatorId: '=',
      auditPackageId: '=',
      hasActiveAuditPackage: '=',
      hasAuditPackageGenerationRequests: '=',
      auditIsActive: '=',
      canEdit: '=',
      canGeneratePackage: '=',
      canDownloadPackage: '=',
    },
    controller: 'FindingCategoriesController',
    controllerAs: 'findingCategoriesVM',

    bindToController: true,
    replace: true
  };
}
